var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultReportIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 17.663 21.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2541"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2540"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.377 8.359h3.184a.5.5 0 0 0 0-1H4.377a.5.5 0 0 0 0 1z",
    "data-name": "Path 620",
    transform: "translate(-40.218) translate(40.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.546 10.597H4.377a.5.5 0 1 0 0 .995h6.169a.5.5 0 0 0 0-.995z",
    "data-name": "Path 621",
    transform: "translate(-40.218) translate(40.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.546 13.834H4.377a.5.5 0 1 0 0 .995h6.169a.5.5 0 0 0 0-.995z",
    "data-name": "Path 622",
    transform: "translate(-40.218) translate(40.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.661 17.562V1.891A1.816 1.816 0 0 0 15.922 0H5.095a2.024 2.024 0 0 0-2.113 1.891v.846h-.871A2.164 2.164 0 0 0 0 4.8v15.7a.871.871 0 0 0 .5.7.771.771 0 0 0 .846-.149l1.517-1.368L4.679 21.3a.746.746 0 0 0 .5.2.8.8 0 0 0 .5-.2l1.791-1.617L9.261 21.3a.746.746 0 0 0 .995 0l1.816-1.617 1.492 1.368a.6.6 0 0 0 .746.149.746.746 0 0 0 .373-.7v-3.535l.3-.224 1.517 1.368a.721.721 0 0 0 .522.2.447.447 0 0 0 .249-.05.721.721 0 0 0 .39-.697zm-3.979 2.388l-1.17-1.144a.7.7 0 0 0-.97-.025L9.726 20.4 7.96 18.783a.8.8 0 0 0-.995 0L5.174 20.4l-1.816-1.617a.821.821 0 0 0-1.07.025L.995 19.95V4.8a1.169 1.169 0 0 1 1.119-1.07h10.7a.967.967 0 0 1 .868 1.07v15.15zm2.984-18.059v15.124l-1.244-1.144c-.2-.2-.249-.249-.746-.174V4.8a1.959 1.959 0 0 0-1.866-2.065H3.982v-.844A1.033 1.033 0 0 1 5.099 1h10.7a.821.821 0 0 1 .872.766.812.812 0 0 1-.005.125z",
    "data-name": "Path 623",
    transform: "translate(-40.218) translate(40.218)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultReportIcon);
export default __webpack_public_path__ + "static/media/DefaultReportIcon.abaf298e8a05e3ae6330eaed8a6de8ee.svg";
export { ForwardRef as ReactComponent };